export default {
  dashboardTitle: "DASHBOARD_TITLE",
  dashboardStatistic: "Statistiques",
  dashboardMemberStatistic: "DASHBOARD_MEMBER_STATISTIC",
  dashboardMemberColumnName: "DASHBOARD_MEMBER_TABLE_COL_NAME",
  dashboardMemberColumnTicketOpened: "DASHBOARD_MEMBER_TABLE_COL_TICKET_OPENED",
  dashboardMemberColumnTicketTotal: "DASHBOARD_MEMBER_TABLE_COL_TICKET_TOTAL",
  dashboardMemberColumnResolution: "DASHBOARD_MEMBER_TABLE_COL_RESOLUTION",
  dashboardMemberTableColumnTicketResolved: "DASHBOARD_MEMBER_TABLE_COL_TICKET_RESOLVED",
  dashboardContractorStatistic: "DASHBOARD_CONTRACTOR_STATISTIC",
  dashboardTableColBlockName: "DASHBOARD_TABLE_COL_BLOCK_NAME"
}


// WEBPACK FOOTER //
// ./src/locales/dashboard/index.ts